export default (props, e) => {
    let hash = window.location.hash.substring(1);
    if (hash == 'back-to-people-list') {
        e.preventDefault();
        window.history.back();
    }
};


// WEBPACK FOOTER //
// ./fe/web-default/src/js/webActions/goBackPeople.js